<template>
  <users-form :user.sync="user" :errors="errors" />
</template>

<script>
import UsersForm from './UsersForm'

export default {
  name: 'UsersNew',
  props: {
    user: { type: Object, required: true },
    errors: Object
  },
  components: { UsersForm }
}
</script>
